export default __webpack_public_path__ + "static/media/fig-05-source-3d-log.b0fc06ec.png";